import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Logout")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_page_wrapper = _resolveComponent("page-wrapper")!

  return (_openBlock(), _createBlock(_component_page_wrapper, null, {
    "content-center": _withCtx(() => [
      _createElementVNode("h1", null, "Hello, " + _toDisplayString(_ctx.firstName) + ".", 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1),
      _createVNode(_component_base_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.AuthStore.logout()))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}